import React from "react";
import { useI18n } from "../i18n";

const testimonials = [
  {
    nameKey: "testimonials.1.name",
    roleKey: "testimonials.1.role",
    quoteKey: "testimonials.1.quote",
    rating: 5,
  },
  {
    nameKey: "testimonials.2.name",
    roleKey: "testimonials.2.role",
    quoteKey: "testimonials.2.quote",
    rating: 5,
  },
  {
    nameKey: "testimonials.3.name",
    roleKey: "testimonials.3.role",
    quoteKey: "testimonials.3.quote",
    rating: 5,
  },
  {
    nameKey: "testimonials.4.name",
    roleKey: "testimonials.4.role",
    quoteKey: "testimonials.4.quote",
    rating: 5,
  },
  {
    nameKey: "testimonials.5.name",
    roleKey: "testimonials.5.role",
    quoteKey: "testimonials.5.quote",
    rating: 4,
  },
  {
    nameKey: "testimonials.6.name",
    roleKey: "testimonials.6.role",
    quoteKey: "testimonials.6.quote",
    rating: 5,
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex gap-0.5">
      {[...Array(5)].map((_, i) => (
        <svg key={i} className={`w-4 h-4 ${i < count ? "text-[#a078d0]" : "text-[#2a2040]"}`} fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
        </svg>
      ))}
    </div>
  );
}

export function Testimonials() {
  const { t } = useI18n();

  return (
    <section className="py-20 px-6" style={{ background: "linear-gradient(180deg, #0a0a12 0%, #12101c 50%, #0a0a12 100%)" }}>
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t("testimonials.title")}
          </h2>
          <p className="text-[#8a7a9a] text-lg max-w-2xl mx-auto">
            {t("testimonials.subtitle")}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((tm) => (
            <div
              key={tm.nameKey}
              className="p-6 rounded-xl onyx-card onyx-glow-hover relative"
            >
              {/* Quote mark */}
              <div className="absolute top-4 right-4 text-[#2a2040] text-4xl font-serif leading-none">"</div>

              <Stars count={tm.rating} />

              <p className="text-sm text-[#b0a0c0] leading-relaxed mt-4 mb-6 italic">
                "{t(tm.quoteKey)}"
              </p>

              <div className="flex items-center gap-3">
                {/* Avatar placeholder */}
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#a078d0] to-[#7b5ea7] flex items-center justify-center text-white text-sm font-bold">
                  {t(tm.nameKey).charAt(0)}
                </div>
                <div>
                  <p className="text-sm font-medium text-white">{t(tm.nameKey)}</p>
                  <p className="text-xs text-[#7a6a9a]">{t(tm.roleKey)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
